import fetchJSON from '@api/api_helper';
import { CustomFieldKeysResponseObject } from '@api/v4/brandfolders/CustomFieldKeysTypes';

const customFieldKeysUrl = (resourceType: string, resourceKey: string): string => `/api/v4/${resourceType}s/${resourceKey}/custom_field_keys`;


// TODO create typed param object
export const getCustomFieldKeys = ({ params = {}, resourceType, resourceKey }): Promise<CustomFieldKeysResponseObject[]> => (
  fetchJSON(customFieldKeysUrl(resourceType, resourceKey), { params })
    .then(({ data }) => data)
    .catch(async (response) => { throw (await response.json()); })
);
